"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wizard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var store_1 = require("../store");
var styles_1 = require("../styles");
var base_1 = require("./base");
var FaCheckCircle_1 = require("@react-icons/all-files/fa/FaCheckCircle");
var MdError_1 = require("@react-icons/all-files/md/MdError");
function Wizard() {
    var store = (0, store_1.useWizardStore)();
    var content = useContent();
    var onClose = (0, react_1.useCallback)(function () {
        store.setOpen(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(base_1.Modal, __assign({ open: store.open, onClose: onClose }, { children: (0, jsx_runtime_1.jsx)(StyledContainer, { children: content }) })));
}
exports.Wizard = Wizard;
var useContent = function () {
    var store = (0, store_1.useWizardStore)();
    return (0, react_1.useMemo)(function () {
        var baseProps = {
            status: store.status,
            error: store.error,
        };
        if (store.action === store_1.WizardAction.APPROVE) {
            return (0, jsx_runtime_1.jsx)(Message, __assign({}, baseProps, { errorMsg: "Approval failed", pendingMsg: "Approving", successMsg: "Approval successful" }));
        }
        if (store.action === store_1.WizardAction.CREATE_ORDER) {
            return (0, jsx_runtime_1.jsx)(Message, __assign({}, baseProps, { errorMsg: "Submit order failed", pendingMsg: "Submitting order", successMsg: "Order submitted successfully" }));
        }
        if (store.action === store_1.WizardAction.WRAP) {
            return (0, jsx_runtime_1.jsx)(Message, __assign({}, baseProps, { errorMsg: "Wrap failed", pendingMsg: "Wrapping", successMsg: "Wrap successful" }));
        }
        if (store.action === store_1.WizardAction.UNWRAP) {
            return (0, jsx_runtime_1.jsx)(Message, __assign({}, baseProps, { errorMsg: "Unwrap failed", pendingMsg: "Unwrapping", successMsg: "Unwrap successful" }));
        }
    }, [store.action, store.status]);
};
var Message = function (_a) {
    var status = _a.status, error = _a.error, successMsg = _a.successMsg, errorMsg = _a.errorMsg, pendingMsg = _a.pendingMsg;
    if (status === store_1.WizardActionStatus.PENDING) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledSpinner, {}), (0, jsx_runtime_1.jsx)(StyledTitle, { children: pendingMsg })] }));
    }
    if (status === store_1.WizardActionStatus.SUCCESS) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FaCheckCircle_1.FaCheckCircle, { className: "twap-icon twap-success-icon" }), (0, jsx_runtime_1.jsx)(StyledTitle, { children: successMsg })] }));
    }
    if (status === store_1.WizardActionStatus.ERROR) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MdError_1.MdError, { className: "twap-icon twap-error-icon" }), (0, jsx_runtime_1.jsx)(StyledTitle, { children: errorMsg }), (0, jsx_runtime_1.jsx)(StyledMessage, { children: error })] }));
    }
    return null;
};
var StyledSpinner = (0, material_1.styled)(base_1.Spinner)({
    width: "45px!important",
    height: "45px!important",
});
var StyledTitle = (0, material_1.styled)(styles_1.StyledText)({
    fontSize: 22,
    fontWeight: 500,
    textAlign: "center",
    width: "100%",
});
var StyledContainer = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    alignItems: "center",
    gap: 12,
    ".twap-icon": {
        width: 60,
        height: 60,
    },
    ".twap-error-icon": {
        "*": {
            color: "#FF3233!important",
        },
    },
    ".twap-success-icon": {
        "*": {
            color: "#28a745!important",
        },
    },
});
var StyledMessage = (0, material_1.styled)(styles_1.StyledText)({
    fontSize: 16,
    textAlign: "center",
    width: "100%",
    marginTop: 10,
});
